import useMediaQuery from '@material-ui/core/useMediaQuery';

export default function MediaQuery() {
  const large = useMediaQuery('(min-width:1000px)')
  const medium = useMediaQuery('(min-width:641px)')
  const small = useMediaQuery('(max-width:640px)')

  return { large, medium, small};
}

/* Estrutura de condição sugerida pro mediaQuery: 
                                                  large ? <renderTelaGrande> 
                                                  : small ? <renderTelaMobile>
                                                  : <renderTelaMedia>
*/